//     _                   _       _
//    | |   _   _ ___  ___(_)_ __ (_) __ _ 
//    | |  | | | / __|/ __| | '_ \| |/ _` |
//    | |__| |_| \__ \ (__| | | | | | (_| |
//    |_____\__,_|___/\___|_|_| |_|_|\__,_|
//
//  Copyright 2014-2020 - Twinvision Software
//
// Luscinia uses jQuery and related libraries such as Bootgrid, Select2 and many others
// to create a user friendly interface for interacting with tabular data. This client side
// library is only using server data and tries not to keep too much state other than
// needed for direct user interaction.
//
// TODO: Remove direct dependencies on other libraries than jQuery and use a client side template and/or binding framework

import { ChangeElement, ChangeType } from "./postValueChanged";
import { WizardState, WizardStepState } from "./wizard";
import { initializeBootgridPlugin } from '../lib/bootgrid/jquery.bootgrid.js';

// Declare Luscinia "class" but in js
export class Luscinia {
    keepSelectionId: any;
    config: Config = {
        culture: "",
        ignoreMessages: false,
        showJobNotifications: true,
        timeZone: "",
        notification: {
            position: "bottom-right",
            duration: 5000
        },
        translations: {
            currencySign: "",
            captionActionNew: "",
            captionActionDownloadSelection: "",
            captionActionAdvancedFilters: "",
            captionActionEdit: "",
            captionActionDelete: "",
            captionNotification: "",
            captionNotificationRecordSaved: "",
            captionConfirmDeleteRecord: "",
            captionConfirmDeleteRecordTitle: "",
            captionConfirmDeleteRecords: "",
            captionConfirmDeleteRecordsTitle: "",
            captionNotificationRecordDeleted: "",
            captionNotificationRecordDeleteFailed: "",
            captionNotificationEmailSent: "",
            captionNotificationForbidden: "",
            captionNotificationRequestTooLarge: "",
            captionNotificationRequestTooLargeDescription: "",
            bootgridAll: "",
            bootgridInfos: "",
            bootgridLoading: "",
            bootgridNoResults: "",
            bootgridRefresh: "",
            bootgridSearch: "",
            captionTotal: ""
        }
    };
    css = {
        rowSelected: "row_selected",
        rowHighlight: "row_selected info",
        bootgrid: "luscinia-bootgrid",
        dataTableSelectionChanged: "luscinia-datatable-selectionchange",
        ajaxSelect: "luscinia-ajax-select",
        inlineSelect: "luscinia-inline-select",
        postElementUrl: "luscinia-post-element-url",
        postElementId: "luscinia-post-element-id",
        postFormCallback: "luscinia-post-form-callback",
        imageUpload: "luscinia-imageupload",
        fileUpload: "luscinia-fileupload"
    };
    data = {
        filterColumnName: "luscinia-filtercolumnname",
        parentFilterColumnName: "luscinia-parentfiltercolumnname",
        keyColumnName: "luscinia-keycolumnname",
        baseUrl: "base-url",
        modalUrl: "modal-url",
        modulePath: "luscinia-modulepath",
        propertyModulePath: "luscinia-property-modulepath",
        tableName: "luscinia-tablename",
        menuItemId: "luscinia-menuitem-id",
        postValueChanged: "luscinia-postvaluechange",
        action: "luscinia-action",
        url: "luscinia-url",
        fieldName: "luscinia-field-name",
        value: "luscinia-value",
        placeHolder: "luscinia-placeholder",
        recordId: "luscinia-record-id",
    };
    identifier = {
        editInlineContent: "#editInlineContent",
    };
    bootgrid = {
        defaults: {
            multiSelection: false,
            selection: false,
            rowSelection: false,
            showCheckBox: false,
            showRefreshButton: true,
            showColumnSelection: true,
            showSearchInput: true,
            showHeaderInfoBar: true,
            showFooterInfoBar: true,
            showActionHeader: true,
            paging: true,
            editGrid: true,
            allowNew: true,
            allowEdit: true,
            allowDelete: true,
            allowExport: true,
            newBtnHrefExtension: "",
            addColumnSearch: false,
            isColumnSearchCollapsed: true,
            inlineEditable:false,
            isAdvancedSearchCollapsed: true,
            columnSearchValues: "{}",
            defaultColumns: null,
            selectedRowCount: 10,
            selectedPageNumber: 1,
            ajax: true,
            isRowEditButtonVisible: true,
            isRowDeleteButtonVisible: true,
            isAutoSizeEnabled: true,
            isAutoSizeEnabledMobile: true,
        },
        data: {
            permaLink: "perma-link",
            multiSelection: "luscinia-multiselection",
            selection: "luscinia-selection",
            rowSelection: "luscinia-rowselection",
            showCheckBox: "luscinia-row-showcheckbox",
            showRefreshButton: "luscinia-showrefreshbutton",
            showColumnSelection: "luscinia-showcolumnselection",
            showSearchInput: "luscinia-showsearchinput",
            showHeaderInfoBar: "luscinia-showheaderinfobar",
            showFooterInfoBar: "luscinia-showfooterinfobar",
            showActionHeader: "luscinia-showactionheader",
            paging: "luscinia-paging",
            editGrid: "luscinia-editgrid",
            allowNew: "luscinia-allow-new",
            allowEdit: "luscinia-allow-edit",
            allowDelete: "luscinia-allow-delete",
            allowExport: "luscinia-allow-export",
            recordView: "luscinia-recordview",
            inRecordView: "luscinia-inrecordview",
            viewType: "luscinia-viewtype",
            customBtn: "luscinia-custombtn",
            newBtnHrefExtension: "luscinia-new-btn-href-extension",
            addColumnSearch: "luscinia-addcolumnsearch",
            isColumnSearchCollapsed: "luscinia-iscolumnsearchcollapsed",
            inlineEditable:"luscinia-inlineeditable",
            isAdvancedSearchCollapsed: "luscinia-isadvancedsearchcollapsed",
            columnSearchValues: "luscinia-columnsearchvalues",
            defaultColumns: "luscinia-defaultcolumns",
            selectedRowCount: "luscinia-selectedrowcount",
            selectedRowId: "luscinia-selectedrowid",
            selectedPageNumber: "luscinia-selectedpagenumber",
            selectedSubTableName: "luscinia-selectedsubtable",
            visibleColumns: "luscinia-defaultcolumns",
            isRowEditButtonVisible: "luscinia-is-row-edit-button-visible",
            isRowDeleteButtonVisible: "luscinia-is-row-delete-button-visible",
            autoSizeEnabled: "luscinia-autosize",
            autoSizeEnabledMobile: "luscinia-autosize-mobile",
        }
    };
    confirmDialog = {
        identifier: {
            modal: "#dialogModal",
            modalWarning: "#warningDialogModal",
            title: "#dialogModalTitle",
            text: "#dialogModalText",
            modalBackdropClass: ".modal-backdrop"
        },
        css: {
            dialogButton: "luscinia-confirm-dialogbutton"
        }
    };
    parameter = {
        identifier: {
            parameterContent: "#parameterContent"
        }
    };

    /**
     * Luscinia's initialization function.
     * This will trigger a sequence of multiple initializations.
     * Should be called after rendering.
     */
    Init!: (config: Config) => void;
    renderWizard: (wizardParameterFullName: string, config: Config) => JQuery.jqXHR;
    /**
     * Initializes all inline modals with id: 'editInline'
     */
    initInlineModal!: () => void;
    /**
     * Core initialization function for all modals
     * 
     * @param form which is supposed to be initialized
     * @param modalIdentifier the id of the modal which should be initialized
     * @param config configuration parameter also known on luscinia.config
     * @param filter optionally passible only the form elements in this filter get initialized (default: form)
     * @param inline if set to false (default) the modal will attempt to do some cleanup which is required for popup modals
     * @param elementIdentifier if set to a html element its new value will be set after closing th
     */
    initModalDialog!: (form: JQuery<HTMLFormElement>, modalIdentifier: string, config: Config, modalAction: string, filter?: any, inline?: boolean, elementIdentifier?: string, customSerializer?: (form: JQuery<HTMLFormElement>) => FormData) => Promise<any>;
    /**
     * Opens a already rendered window with id:'#dialogModal'
     * 
     * @param title the title of the confirmation dialog, id'#dialogModalTitle'
     * @param text the text of the confirmation dialog, id'#dialogModalText'
     * @param callback a function which gets called after the confirmation button is pressed
     */
    showConfirmationDialog!: (title: string, text: string, callback: (e: Event) => void) => Promise<void>;
    showConfirmationDialogWithExtraInput: (title: string, text: string, callback: (inputValue: string) => void) => void;
    /**
     * Opens a already rendered window with id:'#dialogModal'
     * Runs callback only if yes pressed
     * 
     * @param title the title of the confirmation dialog, id'#dialogModalTitle'
     * @param text the text of the confirmation dialog, id'#dialogModalText'
     * @param callback a function which gets called after the confirmation button is pressed
     */
    showConfirmationDialogApplyIfAccepted!: (title: string, text: string, callback: any) => void;
    /**
     * Gets the 'current' modal also known as the modal with the highest layer count.
     */
    getCurrentModal!: () => JQuery<HTMLElement>;
    /**
     * Closes modal with the highest layer count
     */
    closeModal!: () => void;
        /**
     * Closes all open modals
     */
    closeAllModals!: () => void;
    /**
     * Cancels editing a record and returns to a returnUrl
     */
    cancelInlineRecord!: () => void;
    /**
     * Returns the amount of edit modals in the dom
     */
    getModalLayerCount!: () => number;
    /**
     * Renders modal when creating new records.
     * Callback url is build up like so (get): `${url}/modaledit?action=new&layerid=${luscinia.getModalLayerCount()}`
     * 
     * @param url Url which will be called back for the rendering of the content of the modal.
     * @param elementIdentifer Related element id from which the modal is opened
     */
    openCustomModalNew!: (url: string, elementIdentifier?: string) => void;
    /**
     * Renders modal when editing existing records.
     * Callback url is build up like so (get): `${url}/modaledit?action=new&layerid=${luscinia.getModalLayerCount()}`
     *
     * @param url Url which will be called back for the rendering of the content of the modal.
     * @param id The id of the record which you want to edit.
     * @param queryparameter additional parameters which you want to add to the url can be passed here
     */
    openCustomModalEdit!: (url: string, id: any, queryparameter: string) => JQuery.jqXHR;
    /**
     * This opens a popup modal.
     * Additionally you can specify an endpoint for rendering the content.
     * Callback url is build up like so: "url + `/${luscinia.getModalLayerCount()}` + "?" + query"
     * 
     * @param url Url which will be called back for the rendering of the content of the modal, 
     * there will be an integer attached to the end of the callback which indicates the modallayer.
     * @param query Adds this string to the end of the callback url
     */
    openCustomModal!: (url: string, query?: string) => JQuery.jqXHR;
    openCustomReportModal: (url: string) => Promise<void>;
    openNewRecordModal!: (bootgrid: JQuery<HTMLTableElement>, config: Config) => JQuery.jqXHR;
    UpdateModalZIndex!: (dialog: { identifier: { modal: string; modalWarning: string; title: string; text: string; modalBackdropClass: string; }; css: { dialogButton: string; }; }) => void;
    /**
     * Binds all form elements in the form parameter to postvaluechanged callbacks
     * Also triggers initial postvalue change on all form elements
     */
    bindPostValueChanged!: (form: JQuery<HTMLFormElement>, filter?: JQuery<HTMLElement>) => void;
    /**
     * Handles click event on save button on the modal dialog used for editing records
     */
    editModalFormSaveClick!: (sender: any, callback?: any, closeModal?: boolean, redirect?: string, newTab?: boolean) => void;
    /**
     * Handles click event on save button on both modal edit and record page edit.
     */
    handleRecordSave!: (sender: any) => void;
    /**
     * Cancels editing a record and returns to a returnUrl which is the current url without 'record' behind it
     */
    editModalFormCancel!: () => void;
    /**
     * Renders and initializes parameter form
     */
    renderParameter!: (parameterFullName: string, paramData: any, allowNullValues?: boolean) => void;
    /**
     * Renders and initializes parameter form for open email popup
     */
    renderEmailParameter!: (parameterFullName: string, urlExtension?: string) => void;
    /**
     * Renders and initializes a parameter form modal before running an action.
     */
    renderActionParameter!: (parameterFullName: string, actionName: string, moduleType: string, serializedParameter: string, modalTitle?: string) => void;
    /**
     * Renders and initializes parameter form in a modal so the user can edit report parameters before printing.
     * onConfirmJs is an optional URL-encoded JS template with __REPORTURL__ as placeholder.
     */
    renderReportParameter!: (parameterFullName: string, reportName: string, filterObjectId: string, serializedParameter: string, onConfirmJs?: string) => void;
    /**
     * Submits the report parameter form and opens the report PDF in a new tab.
     */
    submitReportParameterForm!: (event: any) => void;
    submitActionParameterForm!: (sender: HTMLElement) => void;
    /**
     * Renders and initializes parameter form for open email popup
     */
    submitForm!: (event: any) => void;
    /**
     * Resets the pin code for a parameter
     */
    resetPinCode!: (parameterFullName: string) => void;
    /**
     * Actually executes all postvaluechange actions
     * 
     * @param form the form which 
     */
    executePostValueChange!: (form: any, propertyModulePath: string, name: string, changeType: ChangeType, changeElement?: ChangeElement, initialTrigger?: boolean, changedValue?: object) => void;
    /**
     * 
     */
    setValue!: (filter: HTMLElement, fieldName: string, value: string) => void;

    executeActionList!: (actions: any, form: any, initialTrigger?: boolean) => void;
    getLocalizedElementValue!: (element: JQuery<HTMLElement>) => string;
    serializeFormObject!: (form: JQuery<HTMLFormElement>) => FormData;
    postFormData: (url: string, form: JQuery<HTMLFormElement>) => JQuery.jqXHR;

    serializeFormElements!: (form: JQuery<HTMLElement>) => { name: string; value: string; }[];
    initFormElements!: (filter: any, form: any) => Promise<any>;
    refreshValidation!: (errorMessage: any, frm: JQuery<HTMLFormElement>, frmSelector: string) => any;
    //Record
    deleteCustomRecord!: (url: string, id: string, onSuccess: any) => void;
    unDelete!: (softRecordId: any) => void;
    runCrudAction!: (actionName: string) => void;
    getActiveForm!: () => JQuery<HTMLFormElement>;
    isCRUDPage!: () => boolean;
    //Bootgrid
    initBootgrids!: (config: Config) => Promise<void>;
    setSortOrder!: (url: string, tableId: string) => void;
    toggleBootgridCheckbox!: (url: string, tableId: string) => void;
    bootgridSelectedRowsToArray!: (bootgrid: any) => any[];
    //GridSplitter
    initGridSplitters!: (filter?: JQuery<HTMLElement>) => void;
    //Select2
    initializeAjaxSelect2!: (element: any, additionalOptions?: any) => any;
    initializeInlineSelect2!: (element: any) => void;
    select2FormatDefault!: (o: any) => any;
    select2FormatUser!: (o: any) => any;
    select2FormatBootstrapStyle!: (o: any) => any;
    //WYSIWYG
    initSummernote!: (form: any, culture: any) => void;
    SummerNoteCleanHtml!: (editor: any, type: any, value: any) => void;
    //Notification
    showNotification!: (title: string, text: string, className: string) => void;
    //Utility
    getFunctionByName!: (functionName: string, context: any, ...args: any[]) => any;
    getPosition!: (element: HTMLElement) => { x: number; y: number; };
    getQueryParameterByKey!: (key: string) => string | null;
    SetCaretAtEnd!: (inputElement: HTMLInputElement) => void;
    objectifyForm!: (formObject: FormData) => {};
    createInteractiveValidator!: (element: any, validationError: any) => void;
    interactiveValidatorResponse!: (element: any, columnName: string, reference: any, value: any) => void;
    initUpdateJobOverview!: (filter?: JQuery<HTMLElement>) => void;
    isHTML!: (str: string) => boolean;
    removeErrors: (element: HTMLInputElement) => void;
    clearFields: (fieldNames: string[]) => void;

    //Wizard
    initWizard!: () => any;
    initMultiSelect2!: (filter: JQuery<HTMLElement>) => Promise<void>;
    initNumberSliders!: (filter: any) => any;
    initCheckboxSwitches!: (filter: any) => any;
    applyWizardState!: (wizardForm: JQuery<HTMLFormElement>, state: WizardState) => void;
    getClosestEnabledStepIndex!: (state: WizardState, currentIndex: number, forward: boolean) => number;
    getWizardStepName!: (state: WizardState, index: number) => string | undefined;
    getWizardStepState!: (state: WizardState, name: string) => WizardStepState | null;
    insertJobOverview!: (state: WizardState, stepIndex: number, wizardForm: JQuery<HTMLFormElement>) => void;
    setStepBtnsEnabled!: (enabled: boolean, contentTab: JQuery<HTMLElement>) => void;
    runWizardAction!: (actionName: string) => void;
    getWizardStepIndex!: (state: WizardState, name: string) => number | null;
    performNextStep!: (wizardNextBtn: JQuery<any>, wizardForm: JQuery<HTMLFormElement>, waitingHtml: string, parameterName: string) => JQuery.jqXHR<any>;
    isWizardPage!: () => boolean;
    //Job
    initJobNotifications!: () => void;
    reRunJob!: (title: string, text: string, jobRunId: string) => void;

    maxFileSize!: (file: any, maxByteSize: number, errorMessage: string) => boolean;
    validateFileFormat!: (fileInput: HTMLInputElement, errorMessage: string) => void;

    /**
    * Usage:
    * This will attempt to translate the passed value by using internally cached resource files
    * 
    * Add translations:
    * You can add values to these resource files by adding a 'Localization' folder in the root of your project.
    * Any '.resx' files in this folder with Build Action 'Embedded Resource' and Custom Tool 'PublicResXFileCodeGenerator' will be registered to this cache
    */
    translate!: (value: string) => Promise<string>;

    //Cards
    addCard!: (button: HTMLElement) => void;
    removeCard!: (button: HTMLElement) => void;
    duplicateEditCard!: (button: HTMLElement) => void;

    //EditGrids
    addEditGridRowUsingButton!: (button: HTMLElement, duplicateRow: boolean, rowData: object) => Promise<void>;
    removeEditGridRow!: (button: HTMLElement, triggerPostValueChange: boolean) => void;
    duplicateEditGridRow!: (button: HTMLElement) => Promise<void>;
    redirectToEmailClient: (receiverAddress: string, subject: string) => void;
    updateMailToMailAddress: (receiverAddress: string, elementSelectorToUpdate: string) => void;
    downloadFileAndRedirectToEmailClient: (receiverAddress: string, subject: string, fileUrl: string, fileName: string) => void;
    downloadFilesAndRedirectToEmailClient: (receiverAddress: string, subject: string, fileUrl: string, fileName: string, peppolFileUrl: string) => void;

    //Form
    createDynamicRequiredForm: (formInputNames: string[], requiredFormInputNames: string[]) => void;

    //User
    sendPasswordResetMail: (emailAddress: string) => void;
    sendSecretKeyResetMail: (emailAddress: string) => void;
    releaseLoginLock: (userId: string) => void;
    showNotificationModal: (title: string, text: string) => void;

    //StagedIntervalConfigurator
    renderStagedIntervalConfiguration: () => void;
    renderNonStagedIntervalConfiguration: () => void;

    apiRequestWithNotification: (url: string, options: object) => Promise<boolean>;    
    
    //Test methods
    isMachineTestEnvironment: () => boolean;

    sendReportEmail: () => Promise<void>;
    downloadReportAndEmail: () => Promise<void>;
    openSendReportEmailModal: () => Promise<void>;

    transferKeyToSupplier: () => Promise<void>;
    transferKeyToCustomer: () => Promise<void>;
    transferKeyToEmployee: () => Promise<void>;
    transferKeyToStorage: (keyId: string) => Promise<void>;

    renderParameterFormModal: (parameterFullClassName: string, modalTitle: string, onSave: ($modal: JQuery) => void) => void;
    constructor() {
    }
}

// Create instance of the luscinia class
// Needs to be "Var" so it is attached to the window object
initializeBootgridPlugin();

export let luscinia = new Luscinia();
